export default __webpack_public_path__ + "alberta-dot-unknown.c912a16067ce41eb2f4e.svg";